import * as React from 'react';
import { getSlots } from '@fluentui/react-utilities';
import { RadioGroupContext } from '../../contexts/RadioGroupContext';
/**
 * Render the final JSX of RadioGroup
 */

export const renderRadioGroup_unstable = (state, contextValues) => {
  const {
    slots,
    slotProps
  } = getSlots(state);
  return /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: contextValues.radioGroup
  }, /*#__PURE__*/React.createElement(slots.root, { ...slotProps.root
  }));
};
//# sourceMappingURL=renderRadioGroup.js.map